import {
    SET_LOADING, SET_STAMPS,SET_STAMPS_TOTAL,SET_STAMP
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
  async fetchStampForms({ commit },  params = {}) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.query("mgmt/stamps",params)
        .then((result) => {
          result =result.data;
          commit(SET_STAMPS, result?.data ?? []);
          commit(SET_STAMPS_TOTAL, result?.total ?? []);
          commit(SET_LOADING, false);

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
          commit(SET_LOADING, false);
        });
  },
  async updateStampForm({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.put("mgmt/stamps/"+params.apply_form_id, params)
        .then((result) => {
          result = result.data;
          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response.data);
          return response.data;
        });
  },
};
